import { Options } from 'axios-hooks';
import { REWARDS_BASE_URL, useAxios } from 'services/kardAPI';
import { IOffer } from '@kardfinancial/models';

const useOffers = (queryParams: string = '') => {
  const [{ data, loading, error }] = useAxios<IOffer[]>({
    // TODO: refactor to use params option instead of manually attaching query params
    url: `${REWARDS_BASE_URL}/portal/merchant/offers?${queryParams}`,
  });

  return [data, loading, error];
};

export default useOffers;

const useOfferById = (offerId: string, options?: Options) =>
  useAxios<IOffer>(
    {
      url: `${REWARDS_BASE_URL}/portal/merchant/offer/${offerId}`,
    },
    options,
  );

export { useOffers, useOfferById };

const useUpdateOffer = (offerId: string) =>
  useAxios<
    IOffer,
    Omit<
      IOffer,
      | '_id'
      | 'merchant'
      | 'createdDate'
      | 'lastModified'
      | 'category'
      | 'isTargeted'
    >
  >(
    {
      url: `${REWARDS_BASE_URL}/portal/merchant/offer/${offerId}`,
      method: 'PUT',
    },
    { manual: true },
  );

export { useUpdateOffer };
